// extracted by mini-css-extract-plugin
module.exports = {"h400":"ew3Dm","h300":"NSc3p","h200":"oMFTo","h100":"ihKUp","b400":"snPZQ","b300":"__8nbgd","b200":"NniI5","b100":"w8Yii","b050":"bQql7"};